import { useHostInfo } from 'store/host-info/hooks/use-host-info';
import { usePaneLayout } from 'hooks/use-pane-layout.hook';

/**
 * Whether the bookings page is drawing its columns.
 *
 * ⛔ NOT A WIDTH. The panes are a TENANT-PORTAL layout: every other host either draws its own chrome
 * around this frame or is a phone, and a booking opening in a column beside the list is only an
 * improvement where the host gives this app the whole page. So the width decides how MANY panes; the
 * host decides whether there are panes at all.
 *
 * ⚠️ Its own module rather than a second export from `use-pane-layout.hook`. That one is imported by
 * the stylesheets for its width constants, and pulling `useHostInfo` -- and redux behind it -- into
 * every `styles.ts` through a constants import is a cost paid by modules that only wanted a number.
 *
 * Read by the bookings page, which lays the columns out, and by the add-on step, which needs to know
 * whether the booking it came from is a column still standing behind it or a page it replaced.
 */
export const useIsPaneLayout = (): boolean => {
  const { isTenantPortalHost } = useHostInfo();
  const paneLayout = usePaneLayout();

  return isTenantPortalHost && paneLayout !== 'single';
};
